import template from './pendingspendings.html';
import controller from './pendingspendings.controller';

let pendingSpendingsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default pendingSpendingsComponent;
